import { useTranslation } from "react-i18next";
import React from "react";
import { cn } from "../utils/style";
function InformationColumn({ title, value, defaultValue, textColor }) {
  const { t } = useTranslation();
  return (
    <div>
      <dt
        className={cn(
          "text-xs font-bold leading-6 text-slate-400 uppercase tracking-widest",
          textColor,
        )}
      >
        {title}
      </dt>
      <dd
        className={cn(
          "mt-1 text-sm font-bold leading-6 text-slate-900 sm:col-span-2 sm:mt-0",
          textColor,
        )}
      >
        {value || defaultValue || (
          <span className="text-slate-300">{t("N/A")}</span>
        )}
      </dd>
    </div>
  );
}
export default InformationColumn;
